export const schoolCalendar = {
  title: "Calendário Escolar",
  subtitle: "Ano letivo 2026/2027 - Datas importantes e eventos do ano académico",
  courseDate: {
    title: "Início e fim do curso",
    start: "Início do curso",
    startDate: "9 de setembro de 2026",
    end: "Fim do curso",
    endDate: "21 de junho de 2027"
  },
  holidays: {
    title: "Férias",
    items: [
      {
        name: "Natal",
        date: "de 22 de dezembro de 2026 a 7 de janeiro de 2027 (ambos inclusive)"
      },
      {
        name: "Entroido (Carnaval)",
        date: "8, 9 e 10 de fevereiro de 2027 (ambos inclusive)"
      },
      {
        name: "Páscoa",
        date: "de 22 a 29 de março de 2027 (ambos inclusive)"
      }
    ]
  },
  publicHolidays: {
    title: "Feriados",
    items: [
      {
        name: "Festa Nacional",
        date: "12 de outubro de 2026"
      },
      {
        name: "Imaculada Conceição",
        date: "8 de dezembro de 2026"
      },
      {
        name: "San Xosé (Dia do Pai)",
        date: "19 de março de 2027"
      },
      {
        name: "Dia do Trabalhador",
        date: "1 de maio de 2027"
      },
      {
        name: "Letras Galegas",
        date: "17 de maio de 2027"
      }
    ]
  },
  nonSchoolDays: {
    title: "Dias não letivos (Xunta)",
    items: [
      {
        name: "Día do Ensino",
        date: "7 de dezembro de 2026"
      }
    ]
  },
  familyCelebrations: {
    title: "Celebrações em Gándara (com famílias)",
    items: [
      {
        name: "Samaín-Magosto",
        date: "30 de outubro de 2026"
      },
      {
        name: "Solstício de inverno",
        date: "21 de dezembro de 2026"
      },
      {
        name: "Entroido",
        date: "5 de fevereiro de 2027"
      },
      {
        name: "Equinócio de primavera",
        date: "18 de março de 2027"
      },
      {
        name: "Festa de fim de curso",
        date: "21 de junho de 2027"
      }
    ]
  },
  familyMeetings: {
    title: "Reuniões com famílias",
    items: [
      {
        name: "Reunião de início de curso",
        date: "7 de setembro de 2026"
      },
      {
        name: "Reunião do 2.º trimestre",
        date: "14 de dezembro de 2026"
      },
      {
        name: "Reunião de fim de curso",
        date: "14 de junho de 2027"
      }
    ]
  }
};
